import React from "react"

const Tag = ({ label, className = 'text-sm', style, onClick = () => {} }) => {

    const finalLabel = label?.replace(/-/g, " ");
  return (
    <React.Fragment>
      <div style={style} className={`px-2.5 py-1  rounded-full uppercase ${finalLabel === "new & hot" ? "bg-[#D30000] text-white" : "bg-white text-black"} ${className}`} onClick={onClick}>{finalLabel}</div>
    </React.Fragment>
  )
}

export default Tag
